import { useMemo } from "react"
import PropTypes from "prop-types"
import { map } from "lodash"
import { Table } from "@mui/material"
import ContributorsTableContent from "components/contributors-table-content"
import { sortData } from "helpers/contributorsSort"
import { VIEW_TYPES } from "helpers/base"
import { METRIC_TYPES } from "helpers/assets/constants"
import { METRIC_TYPES_SHAPE } from "helpers/metrics/shapes"
import { getScaledPerformanceFormatter } from "helpers/analyze"
import { buildScaledCurrencyLabel } from "helpers/metrics/currency-scale-label"
import ContributorsTableGroupHead from "components/contributors-table-group-head"

function getLabel(viewType, metricType, currencyScale, currency) {
  const viewTypeLabel = getViewTypeLabel(viewType)
  if (metricType === METRIC_TYPES.CURRENCY_PERFORMANCE) {
    return buildScaledCurrencyLabel(`Perf. (${viewTypeLabel})`, currencyScale, currency)
  }
  return `% Perf. (${viewTypeLabel})`
}

function getTooltipText(viewType, metricType) {
  const metricTypeLabel = metricType === METRIC_TYPES.CURRENCY_PERFORMANCE ? "Performance" : "% Performance"
  return `${metricTypeLabel} (${getViewTypeLabel(viewType)})`
}

function getViewTypeLabel(viewType) {
  return viewType === VIEW_TYPES.ABSOLUTE ? "Absolute" : "Active"
}

function DailyDetails({ viewType, disabled, data, show, factorTable, openFactorProfile, groupSort, groupOrder, metricType, currency }) {
  const { formatter, currencyScale } = useMemo(
    () => getScaledPerformanceFormatter(metricType, map(data, "value")),
    [metricType, data],
  )

  return <Table>
    <ContributorsTableGroupHead {...{
      tooltipText: getTooltipText(viewType, metricType),
      groupOrder,
      groupSort,
      label: getLabel(viewType, metricType, currencyScale, currency),
    }}
    />
    <ContributorsTableContent
      factors
      openFactorProfile={openFactorProfile}
      data={sortData(data, groupOrder)}
      show={show}
      disabled={disabled}
      factorTable={factorTable}
      formatter={formatter}
    />
  </Table>
}

DailyDetails.propTypes = {
  viewType: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  data: PropTypes.array.isRequired,
  factorTable: PropTypes.bool.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  show: PropTypes.func.isRequired,
  groupSort: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  metricType: METRIC_TYPES_SHAPE,
  currency: PropTypes.string,
}

export default DailyDetails
